import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Alert } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminFooter from "./AdminFooter";
import { ReactDialogBox } from "react-js-dialog-box";
export const AdminContractfiles = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [gdata, getData] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [isClickedclient, setIsClickedclient] = useState(false);
  const [showAlerts, setShowAlerts] = useState(false);
  const [showAlertts, setShowAlertts] = useState(false);
  const [message, setmessage] = useState("");
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [tab1, settab1] = useState(false);
  const [tab2, settab2] = useState(false);
  const [tab3, settab3] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selecttype, setSelecttype] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const [deleteerror, setdeleteerror] = useState(false);
  const [getfolder, setgetfolder] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [checkboxes, setCheckboxes] = useState([]);
  const [deletemessage, setdeletemessage] = useState(false);
  const [docUp1, setdocUp1] = useState(false);
  const [isuserId, setisuserId] = useState([]);
  const [foldernamesh, setfoldernamesh] = useState("");
  const fileInputRef = useRef(null);
  const [distrue, setdistrue] = useState(true);
  const { id } = useParams();
  const apiURL = "https://jlmining.app/";
  const handlegetClient = (clientId, index) => {
    setSelectedIndices(
      (prevSelected) =>
        prevSelected.includes(index)
          ? prevSelected.filter((i) => i !== index) // Remove if already selected
          : [...prevSelected, index] // Add if not selected
    );
    setisuserId(
      (prevIds) =>
        prevIds.includes(clientId)
          ? prevIds.filter((id) => id !== clientId) // Remove if already selected
          : [...prevIds, clientId] // Add if not selected
    );
  };
  useEffect(() => {
    if (id === undefined) {
      navigate("/contract-folder");
    }
  }, [id]);
  useEffect(() => {
    const checkidvalid = () => {
      let formdata = {
        id: id,
      };
      axios
        .post(
          "https://jlmining.app/api/admincontracts/checkidvalid",
          formdata,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.row.length === 0) {
            navigate("/admin/contract-folder");
          } else {
            setfoldernamesh(res.data.row[0]);
          }
        })
        .catch((err) => { });
    };
    checkidvalid();
  }, [id]);
  useEffect(() => {
    if (selectedIndices.length > 0) {
      setIsClickedclient(true);
    } else {
      setIsClickedclient(false);
    }
  }, [selectedIndices]);
  useEffect(() => {
    if (selectedIndices.length > 0 && checkboxes.length > 0) {
      setdistrue(false);
      setIsClickedclient(true);
    } else {
      setdistrue(true);
      setIsClickedclient(false);
    }
  }, [selectedIndices, checkboxes]);
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  useEffect(() => {
    changeFavicon(require("../assets/admin/images/f-icon.png"));
    document.title = "Contract Page";
    const userStr = JSON.parse(localStorage.getItem("admin"));
    console.log(userStr);
    if (userStr == null) {
      navigate("/admin/login");
    }
    axios
      .get("https://jlmining.app/admin/getemployee", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data.results);
        setData(res.data.results);
      })
      .catch((err) => { });
  }, []);
  useEffect(() => {
    let formdata = {
      id: id,
    };
    axios
      .post(
        "https://jlmining.app/api/admincontracts/getcontrectfiledWithfolder",
        formdata,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setgetfolder(res.data.results);
      })
      .catch((err) => { });
  }, []);
  const getallfiles = () => {
    let formdata = {
      id: id,
    };
    axios
      .post(
        "https://jlmining.app/api/admincontracts/getcontrectfiledWithfolder",
        formdata,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setgetfolder(res.data.results);
      })
      .catch((err) => { });
  };
  const handleedit = (event) => {
    setIsClickedclient(!isClickedclient);
  };
  const handleSubmit = (event) => {
    setdocUp1(true);
    event.preventDefault();
    const vl = event.target;
    let formdata = {
      folder: vl.folder.value,
    };
  };
  useEffect(() => {
    const userStr = JSON.parse(localStorage.getItem("admin"));
    console.log(userStr);
    if (userStr == null) {
      navigate("/admin/login");
    }
    let formdata = {};

    if (selectAll === true) {
      setSelecttype(true);
    } else {
      setSelecttype(false);
    }
  }, [selectAll]);
  const closeBox = () => {
    setisOpen(false);
  };

  const deletefolder_tab1 = () => {
    if (checkboxes.length > 0) {
      settab1(true);
    } else {
      setdeletemessage(true);
      setTimeout(() => {
        setdeletemessage(false);
      }, 4500);
    }
  };
  const deletefolder = () => {
    if (checkboxes.length > 0) {
      settab2(false);

      setdeletemessage(false);
      let formdata = {
        multi_Id: checkboxes,
        folder_id: id,
      };
      axios
        .post(
          "https://jlmining.app/api/admincontracts/deletefoldercontractFiles",
          formdata,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          settab3(true);
          setCheckboxes([]);
          setSelectAll(false);
          var alldata = res.data.results;
          setgetfolder(alldata);
          setdeleteerror(true);
          getallfiles();
          setTimeout(() => {
            setdeleteerror(false);
            setShowAlert(false);
            settab3(false);
          }, 4500);
        })
        .catch((err) => { });
    } else {
      setdeletemessage(true);
      setTimeout(() => {
        setdeletemessage(false);
      }, 4500);
    }
  };
  const checkall = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const updatedCheckboxes = getfolder.map((item, index) => ({
        id: item.id,
        isChecked: true,
      }));
      setCheckboxes(updatedCheckboxes);
      console.log(updatedCheckboxes);
    } else {
      setCheckboxes([]);
    }
  };

  const handleCheckboxChange = (id, index, event) => {
    const isChecked = event.target.checked;
    let updatedCheckboxes = [...checkboxes];

    const checkboxIndex = updatedCheckboxes.findIndex(
      (checkbox) => checkbox.id === id
    );

    if (isChecked) {
      if (checkboxIndex === -1) {
        updatedCheckboxes.push({ id, isChecked });
      } else {
        updatedCheckboxes[checkboxIndex].isChecked = isChecked;
      }
    } else {
      if (checkboxIndex !== -1) {
        updatedCheckboxes.splice(checkboxIndex, 1);
      }
    }
    setCheckboxes(updatedCheckboxes);
  };

  const closetab1 = () => {
    settab1(false);
  };
  const opentab2 = () => {
    settab1(false);
    settab2(true);
  };
  const closetab2 = () => {
    settab2(false);
  };
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleSubmitfiles = (event) => {
    event.preventDefault();
    if (selectedFiles.length === 0) {
      alert("Please select at least one file.");
      return;
    }

    console.log("Uploading files:", selectedFiles);
    let formData = new FormData();

    // Append each selected file
    Array.from(selectedFiles).forEach((file) => {
      formData.append("files", file);
    });
    formData.append("folder_id", id);
    // Append multiple user IDs (convert array to JSON string)
    formData.append("isuserId", JSON.stringify(isuserId));
    axios
      .post(
        "https://jlmining.app/api/admincontracts/savecontractfileswithfolder",
        formData,
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((res) => {
        setShowAlert(true);
        setShowAlert({ type: "success" });
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        getallfiles();
        setSelectedFiles([]);
        setTimeout(() => {
          setShowAlert(false);
        }, 3500);
      })
      .catch((err) => { });
  };
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length > 10) {
      alert("You can only upload up to 10 files.");
      event.target.value = ""; // Reset the file input
      return;
    }

    setSelectedFiles(files);
  };
  const handlesendFile = () => {
    if (selectedIndices.length > 0 && checkboxes.length > 0) {
      let formdata = {
        user_id: isuserId,
        files: checkboxes,
      };
      axios
        .post(
          "https://jlmining.app/api/admincontracts/sendcontractFiles",
          formdata,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          const { insertedFiles, alreadyExists } = res.data;

          let message = "Files send successfully.\n";

          if (alreadyExists.length > 0) {
            message += "These files were already assigned:\n";
            alreadyExists.forEach((file) => {
              message += `- ${file.fullName} (User ID: ${file.userId})\n`;
            });
          }

          setmessage(message); // Ensure 'setMessage' is correctly used in your state hook

          setShowAlertts(true);
          setShowAlertts({ type: "success" });

          setTimeout(() => {
            setShowAlertts(false);
            setSelectedIndices([]);
            setisuserId([]);
            setCheckboxes([]);
            //window.location.reload();
          }, 3500);
        })
        .catch((err) => { });
    }
  };
  const searcfilename = (event) => {
    console.log(event.target.value);
    let formdata = {
      search: event.target.value,
      id: id,
    };
    axios
      .post("https://jlmining.app/api/admincontracts/searchfile", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        var alldata = res.data.results;
        setgetfolder(alldata);
      })
      .catch((err) => { });
  };
  const searcfileemployee = (event) => {
    console.log(event.target.value);
    let formdata = {
      search: event.target.value,
    };
    axios
      .post(
        "https://jlmining.app/api/admincontracts/searcfileemployee",
        formdata,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setData(res.data.results);
      })
      .catch((err) => { });
  };
  return (
    <>
      <div>
        <AdminHeader />
        <div className="main-right-body">
          <div className="block-full">
            <div className="row gy-4">
              <div className="col-lg-4">
                {showAlert?.type === "error" && (
                  <Alert
                    type="error"
                    description="Client deleted successfully!"
                    closable
                  />
                )}
                {showAlerts?.type === "errors" && (
                  <Alert
                    type="error"
                    description="You have no permissions to delete this client, because this client use for roster"
                    closable
                  />
                )}
                <div className="d-block red-heading bg-white shadow p-4">
                  <div className="col-lg-12 over-empl">
                    <div className="d-flex justify-content-between  align-items-center gap-2 flex-wrap mb-4">
                      <Link
                        to="/admin/contract-folder"
                        className="btn btn-secondary d-flex justify-content-center align-items-center"
                      >
                        Back
                      </Link>
                      <h5 className="fs-24 fw-bold  text-danger text-center">
                        Folder Name <strong>({foldernamesh.name})</strong>
                      </h5>
                    </div>
                    <div className="right-form-box bg-white ">
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex justify-content-between">
                          <input
                            type="text"
                            className="form-control w-50"
                            onInput={searcfilename}
                            placeholder="Search file..."
                          />
                        </div>

                        <div className="row mt-4">
                          <div className=" d-flex gap-2 align-items-center">
                            <input
                              className="-input"
                              type="checkbox"
                              checked={selectAll}
                              onChange={checkall}
                              id="flexCheckDefault"
                            />
                            <label className="-label " for="flexCheckDefault">
                              Select All
                            </label>

                            <Link
                              to="javascript:void(0)"
                              onClick={deletefolder_tab1}
                            >
                              Delete
                            </Link>
                          </div>
                        </div>

                        {deleteerror && (
                          <span className="text-danger">
                            Folder has been deleted successfully
                          </span>
                        )}
                        {deletemessage && (
                          <span className="text-danger mt-4">
                            Please choose atleast one folder
                          </span>
                        )}
                        <div className="row scroll-text-box">
                          {Array.isArray(getfolder) && getfolder.length > 0 ? (
                            getfolder.map((item, index) => (
                              <div
                                className=" d-flex gap-2 align-items-center border-bottom py-2"
                                key={index}
                              >
                                <input
                                  className="-input"
                                  type="checkbox"
                                  onChange={(event) =>
                                    handleCheckboxChange(
                                      item.id,
                                      checkboxes.findIndex(
                                        (checkbox) => checkbox.id === item.id
                                      ),
                                      event
                                    )
                                  }
                                  checked={
                                    (checkboxes.find(
                                      (checkbox) => checkbox.id === item.id
                                    ) &&
                                      checkboxes.find(
                                        (checkbox) => checkbox.id === item.id
                                      ).isChecked) ||
                                    false
                                  }
                                  key={index}
                                  id={`folderCheckbox_${index}`}
                                />
                                <Link
                                  to={`${apiURL}uploads/contractfolder/${foldernamesh.name}/${item.name}`}
                                  target="_blank"
                                  download
                                >
                                  <img
                                    src={require("../assets/images/4347587.png")}
                                    width="30"
                                    alt="Download"
                                  />{" "}
                                  {item.name}
                                </Link>
                              </div>
                            ))
                          ) : (
                            <div>
                              <p>No data available</p>
                            </div>
                          )}
                        </div>
                      </div>
                      {tab1 && (
                        <>
                          <ReactDialogBox
                            closeBox={closeBox}
                            closeButtonColor="white"
                            bodyTextColor="black"
                            bodyHeight="280px"
                          >
                            <style>
                              {`
                                                                                      header._br_-q {
                                                                                        display: none;
                                                                                      }
                                                                                    `}
                            </style>
                            <div
                              style={{
                                height: "250px",
                                paddingTop: "20px",
                              }}
                            >
                              <div className="d-flex flex-column gap-3 bg-white p-4 inperson mt-4">
                                <div className="text-center">
                                  <img
                                    src={require("../assets/images/3997872.png")}
                                    width="100"
                                    alt="Image"
                                  />
                                  <h4 className="text-danger">Confirmation</h4>
                                  <span>
                                    <b>
                                      Are You Sure You Want To Delete This File
                                    </b>
                                  </span>
                                  <br />
                                  <span
                                    className="color-grey"
                                    style={{ fontSize: "12px" }}
                                  >
                                    If you delete this file, you might lose it
                                    permanently and won't be able to retrieve
                                    it.
                                    <br /> Please think carefully before
                                    proceeding.
                                  </span>
                                  <div className="d-flex justify-content-between ">
                                    <button
                                      onClick={opentab2}
                                      type="button"
                                      className=" btn btn-danger"
                                    >
                                      Yes
                                    </button>
                                    <button
                                      type="button"
                                      onClick={closetab1}
                                      className=" btn btn-success"
                                    >
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ReactDialogBox>
                        </>
                      )}
                      {tab2 && (
                        <>
                          <ReactDialogBox
                            closeBox={closeBox}
                            closeButtonColor="white"
                            bodyTextColor="black"
                            bodyHeight="280px"
                          >
                            <style>
                              {`
                                                                                      header._br_-q {
                                                                                        display: none;
                                                                                      }
                                                                                    `}
                            </style>
                            <div
                              style={{
                                height: "250px",
                                paddingTop: "20px",
                              }}
                            >
                              <div className="d-flex flex-column gap-3 bg-white p-4 inperson mt-4">
                                <div className="text-center">
                                  <img
                                    src={require("../assets/images/2959016.png")}
                                    width="100"
                                    alt="Image"
                                  />
                                  <h4 className="text-danger">Confirmation</h4>
                                  <span>
                                    <b>Still You have chance by clicking No</b>
                                  </span>

                                  <div className="d-flex justify-content-between ">
                                    <button
                                      type="button"
                                      onClick={closetab2}
                                      className=" btn btn-success"
                                    >
                                      No
                                    </button>
                                    <button
                                      type="button"
                                      className=" btn btn-danger"
                                      onClick={deletefolder}
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ReactDialogBox>
                        </>
                      )}
                      {tab3 && (
                        <>
                          <ReactDialogBox
                            closeBox={closeBox}
                            closeButtonColor="white"
                            bodyTextColor="black"
                            bodyHeight="280px"
                          >
                            <style>
                              {`
                                                                                      header._br_-q {
                                                                                        display: none;
                                                                                      }
                                                                                    `}
                            </style>
                            <div
                              style={{
                                height: "250px",
                                paddingTop: "20px",
                              }}
                            >
                              <div className="d-flex flex-column gap-3 bg-white p-4 inperson mt-4">
                                <div className="text-center">
                                  <img
                                    src={require("../assets/images/2441914.png")}
                                    width="100"
                                    alt="Image"
                                  />
                                  <h4 className="text-danger">Deleted</h4>
                                  <span>
                                    You have successfully deleted the file
                                    <br />
                                    that you don't want
                                  </span>
                                </div>
                              </div>
                            </div>
                          </ReactDialogBox>
                        </>
                      )}
                      {isOpen && (
                        <>
                          <ReactDialogBox
                            closeBox={closeBox}
                            modalWidth="50%"
                            headerBackgroundColor="red"
                            headerTextColor="white"
                            headerHeight="40"
                            closeButtonColor="white"
                            bodyBackgroundColor="white"
                            bodyTextColor="black"
                            bodyHeight="280px"
                            headerText="Add Folder"
                          >
                            <div
                              style={{
                                height: "250px",
                                paddingTop: "20px",
                              }}
                            >
                              <div className="d-flex flex-column gap-3 bg-white inperson mt-4">
                                {showAlert?.type === "error" && (
                                  <span className="text-danger">
                                    This folder is already exists
                                  </span>
                                )}
                                <form
                                  action="javascript:void(0)"
                                  onSubmit={handleSubmit}
                                  method="post"
                                >
                                  <div className="d-flex flex-column gap-2">
                                    <div className="mb-3">
                                      <label
                                        for="exampleFormControlInput1"
                                        className="form-label"
                                      >
                                        Create Folder
                                      </label>
                                      <input
                                        type="text"
                                        name="folder"
                                        required
                                        className="form-control"
                                        id="exampleFormControlInput1"
                                        placeholder="Enter here..."
                                      />
                                    </div>
                                    <div className="mb-3">
                                      <button
                                        type="submit"
                                        style={{
                                          background: "#F71701 !important",
                                        }}
                                        className={`btn btn-danger${docUp1 === true ? "docup" : ""
                                          }`}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </ReactDialogBox>
                        </>
                      )}

                      <span className="fs-20 text-center"></span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-8">
                <div className="">
                  <div className="block-full">
                    <div className="row gy-4">
                      <div className="col-lg-12">
                        <div className="right-form-box bg-white shadow p-4">
                          <h5 className=" fs-24 fw-bold mb-3 text-danger text-center">
                            Upload Contract Document
                          </h5>
                          {showAlert?.type === "success" && (
                            <Alert
                              type="success"
                              description="Files has been uploaded successfully"
                              closable
                            />
                          )}
                          <form action="" onSubmit={handleSubmitfiles}>
                            <div className="row gy-2">
                              <div className="col-12 col-lg-6">
                                <div className="d-flex flex-column gap-2">
                                  <label for="">Choose File </label>
                                  <input
                                    type="file"
                                    ref={fileInputRef}
                                    name="files"
                                    id="fileInput"
                                    onChange={handleFileChange}
                                    multiple
                                    accept="application/pdf" // ✅ Restrict to PDF files only
                                    placeholder="type here"
                                  />
                                </div>
                              </div>

                              <div className="col-12">
                                <div className="d-flex align-items-center gap-3 justify-content-end">
                                  <button className="sub-btn" type="submit">
                                    Upload
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="right-form-box bg-white shadow p-4">
                          <h5 className=" fs-24 fw-bold mb-3 text-danger text-center">
                            Select Employee
                          </h5>
                          {showAlertts?.type === "success" && (
                            <Alert
                              type="success"
                              description={message}
                              closable
                            />
                          )}
                          <div className="col-lg-12 over-empl">
                            <div className="right-form-box bg-white p-2 ">
                              <div className="d-flex flex-column gap-2">
                                <div className="d-flex justify-content-between mb-4">
                                  <h4 className="fs-5">Select Employee</h4>
                                  <input
                                    type="text"
                                    className="form-control w-50"
                                    onInput={searcfileemployee}
                                    placeholder="Search employee..."
                                  />
                                  <button
                                    onClick={handlesendFile}
                                    type="submit"
                                    disabled={distrue}
                                    className="sub-btn"
                                    style={{
                                      opacity: distrue ? 0.1 : 1,
                                      pointerEvents: distrue ? "none" : "auto",
                                    }}
                                  >
                                    Send Files
                                  </button>
                                </div>

                                <div className="d-flex flex-column h-100 clientselectmain">
                                  {Array.isArray(data) ? (
                                    data.map((item, index) => (
                                      <Link
                                        to="javascript:void(0)"
                                        className={`item ${selectedIndices.includes(index)
                                            ? "active"
                                            : ""
                                          }`}
                                        onClick={() =>
                                          handlegetClient(item.id, index)
                                        }
                                      >
                                        {item.step2_title} {item.first_name}{" "}
                                        {item.last_name}{" "}
                                      </Link>
                                    ))
                                  ) : (
                                    <Link> No data available </Link>
                                  )}
                                </div>
                              </div>

                              <span className="fs-20 text-center"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AdminFooter />
      </div>
    </>
  );
};
